import * as R from 'ramda';
import sampleSeries from './sample-series';
import scatterSeries from './scatter-series';
import timelineSeries from './timeline-series';
import symbolSeries from './symbol-series';
import stackedSeries from './stacked-series';
import choroSeries from './choro-series';
import { getObservationsFormaterAttributes } from '../observation-formater';

export default ({ type, data, options, singularity }) => {
  const { display, formatterIds, map } = options;

  const { attributes = [] } = data;
  const formaterAttributes = getObservationsFormaterAttributes(attributes, formatterIds);

  const indexedDimensions = R.reduce(
    (acc, dim) => {
      if (dim.header) {
        return acc;
      }
      return R.assoc(dim.id, dim, acc);
    },
    {},
    data.dimensions || [],
  );

  switch (type) {
    case 'BarChart':
    case 'RowChart':
      return sampleSeries(type, data, indexedDimensions, display, formaterAttributes);
    case 'ScatterChart':
      return scatterSeries(data, indexedDimensions, singularity, display, formaterAttributes);
    case 'TimelineChart':
      return timelineSeries(data, indexedDimensions, display, formaterAttributes);
    case 'HorizontalSymbolChart':
    case 'VerticalSymbolChart':
      return symbolSeries(data, type, indexedDimensions, singularity, display, formaterAttributes);
    case 'StackedBarChart':
      return stackedSeries(data, indexedDimensions, singularity, display, formaterAttributes, [
        'y',
        'x',
      ]);
    case 'StackedRowChart':
      return stackedSeries(data, indexedDimensions, singularity, display, formaterAttributes, [
        'x',
        'y',
      ]);
    case 'ChoroplethChart':
      return choroSeries(data, indexedDimensions, map, display);
    default:
      return [];
  }
};
